import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';

@Component({
    selector: 'fcp-badge',
    imports: [CommonModule, BadgeModule, OverlayBadgeModule],
    styleUrl: './fcp-badge.component.less',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[attr.data-e2e-hook]': 'e2e()'
    },
    // Inline style is used to override the PrimeNG badge styles when the badge is an overlay badge
    template: `
        @if (overlay()) {
            <p-overlaybadge
                [value]="value()"
                [severity]="severity()"
                [badgeSize]="badgeSize()"
                [size]="badgeSize()"
                [badgeDisabled]="false"
                [class]="emphasis()"
                [style]="overlayBadgeWidth()"
            >
                <ng-content></ng-content>
            </p-overlaybadge>
        } @else {
            <p-badge
                [value]="value()"
                [severity]="severity()"
                [badgeSize]="badgeSize()"
                [size]="badgeSize()"
                [badgeDisabled]="false"
                [styleClass]="emphasis()"
            />
        }
    `
})
export class FcpBadgeComponent {
    readonly overlayBadgeWidth = computed(() => {
        const widthBySize: Record<BadgeSize, string> = {
            [BadgeSize.Small]: '16',
            [BadgeSize.Normal]: '28'
        };

        return `width:var(--spacing-${widthBySize[this.badgeSize()]})`;
    });

    e2e = input<string | null>(null);
    value = input<string>('');
    severity = input<BadgeSeverity>(BadgeSeverity.Primary);
    badgeSize = input<BadgeSize>(BadgeSize.Normal);

    overlay = input<boolean>(false);
    emphasis = input<BadgeEmphasis>(BadgeEmphasis.Strong);
}

export enum BadgeEmphasis {
    Strong = 'strong',
    Subtle = 'subtle'
}

export enum BadgeSeverity {
    Primary = 'primary',
    Secondary = 'secondary',
    Promotional = 'contrast',
    Success = 'success',
    Info = 'info',
    Warn = 'warn',
    Danger = 'danger'
}

export enum BadgeSize {
    Small = 'small',
    Normal = 'normal'
}
